export function drawImageFit(ctx, img, canvas, scale = 1, offsetX = 0, offsetY = 0) {

  //console.log("values in drawImageFit:", canvas,scale,offsetX,offsetY);
  const cw = canvas.width;
  const ch = canvas.height;

  const iw = img.width;
  const ih = img.height;

  const canvasRatio = cw / ch;
  const imgRatio = iw / ih;

  let drawW, drawH;

  if (imgRatio > canvasRatio) {
    drawW = cw * scale;
    drawH = (cw / imgRatio) * scale;
  } else {
    drawH = ch * scale;
    drawW = (ch * imgRatio) * scale;
  }

  const dx = (cw - drawW) / 2 + offsetX;
  const dy = (ch - drawH) / 2 + offsetY;

  ctx.drawImage(img, dx, dy, drawW, drawH);

  return {
  dx,
  dy,
  drawW,
  drawH,
  canvasWidth: cw,
  canvasHeight: ch,
  imageWidth: iw,
  imageHeight: ih
};

}
